import React, { useState } from 'react';
import { useHistory } from 'react-router';
import {
    Link,
    makeStyles,
    Theme, Typography,
} from '@material-ui/core';

import { Page } from '../../components/Page';
import { TextField } from '../../components/TextField';
import { Button } from '../../components/Button';
import { FormGroup } from '../../components/FormGroup';
import { Block } from '../../components/Block';
import { PageBody } from '../../components/PageBody';
import { api } from '../../api';
import { useLoading } from '../../units/loading';
import { StatusFalseError } from '../../api/error/StatusFalseError';
import { useAlert } from '../../units/alert';
import { ForgetPasswordRequestData } from '../../api/forgetPassword';
import { Logo } from '../../components/Logo';

type ForgetPasswordPageProps = {};

ForgetPasswordPage.defaultProps = {};

const useStyles = makeStyles((theme: Theme) => ({
    root: {

    },
    title: {
        margin: theme.spacing(2, 1),
    },
}));

function ForgetPasswordPage(props: ForgetPasswordPageProps): React.ReactElement {
    const classes = useStyles();
    const history = useHistory();
    const { setIsLoading } = useLoading();
    const alert = useAlert();

    const [formData, setFormData] = useState<ForgetPasswordRequestData>({
        login: '',
    });

    function handleRegisterClick() {
        setIsLoading(true);
        api.forgetPassword(formData)
            .then(() => {
                setIsLoading(false);
                alert.show({
                    type: 'success',
                    title: '操作成功',
                    message: '已發送驗證信至您的信箱',
                    onConfirm: () => {
                        history.replace('/login');
                    },
                });
            })
            .catch(async (e) => {
                setIsLoading(false);
                if (e instanceof StatusFalseError) {
                    const errorData = await e.response.json();
                    alert.show({
                        type: 'error',
                        title: '錯誤',
                        message: errorData.msg,
                    });
                }
            });
    }

    return (
        <Page className={classes.root}>
            <PageBody>
                <Logo />
                <Typography className={classes.title} variant="h5" align="center">忘記密碼</Typography>
                <FormGroup>
                    <TextField
                        label="帳號(E-mail)"
                        value={formData.login}
                        onChange={(e) => setFormData({
                            ...formData,
                            login: e.target.value,
                        })}
                    />
                    <Button onClick={handleRegisterClick}>發送驗證信</Button>
                    <Block row justifyContent="center">
                        <Link component="a" onClick={() => history.replace('/login')}>點此返回登入頁</Link>
                    </Block>
                </FormGroup>
            </PageBody>
        </Page>
    );
}

export { ForgetPasswordPage };
